import React from 'react';

function ARIcon(props) {
  return (
    <svg
    width={41}
    height={40}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0.0429688 0H40.043V40H0.0429688V0Z" fill="white" />
    <path d="M10 26.6873V31.1607H14.4734" stroke="black" />
    <path d="M27.6602 31.1606L32.1336 31.1606L32.1336 26.6872" stroke="black" />
    <path d="M32.1328 13.9736L32.1328 9.50024L27.6594 9.50024" stroke="black" />
    <path d="M14.4727 9.5L9.99926 9.5L9.99926 13.9734" stroke="black" />
    <path
      d="M27.7199 25.5723L27.3894 25.7427C27.3697 25.7701 27.3445 25.7914 27.3165 25.8066L21.0896 29.0115C21.0364 29.0389 20.9748 29.0389 20.9244 29.0175C20.9188 29.0145 14.2801 25.5723 14.2801 25.5723C14.1092 25.484 14 25.2923 14 25.0884V16.7004C14 16.603 14.0504 16.5299 14.1289 16.4934C14.1597 16.4812 18.549 14.4969 18.6527 14.4512C18.6695 14.4451 18.6863 14.439 18.7031 14.436L20.8123 13.4895C20.8739 13.4621 20.9356 13.4499 21 13.4499C21.0644 13.4499 21.1289 13.4621 21.1877 13.4895C21.2325 13.5108 21.2773 13.529 21.3193 13.5503C21.4426 13.6051 27.6303 16.3839 27.7507 16.4356C27.8319 16.4721 27.9188 16.5026 27.9636 16.5695C27.986 16.603 28 16.6426 28 16.7004V25.0884C28 25.2923 27.8908 25.484 27.7199 25.5723ZM14.4202 25.0884C14.4202 25.1188 14.437 25.1462 14.4622 25.1614L20.7899 28.4423V19.8991L14.4202 17.0413V25.0884ZM21.028 13.9125C21.0112 13.9034 20.9888 13.9034 20.972 13.9125L17.479 15.4799C17.465 15.486 17.451 15.4891 17.4398 15.4921L14.7619 16.6973L21.0028 19.4974L27.2437 16.6973L21.028 13.9125ZM27.5798 17.0413L21.2101 19.8991V28.4423L25.9496 26.0045C25.9692 25.9831 25.9916 25.9618 26.0168 25.9497L27.5406 25.1584C27.5658 25.1462 27.5826 25.1157 27.5826 25.0853V17.0413H27.5798Z"
      fill="black"
      stroke="black"
      strokeWidth={0.5}
    />
  </svg>
  );
}

export default ARIcon;